import { Link } from "react-router-dom";
import { Receipt } from "@phosphor-icons/react";
import RoleGuard from "../../components/RoleGuard";
import { Button } from "../../components/ui/button";
import { formatINR, formatDate } from "../../lib/format";
import { cn as classJoin } from "../../lib/utils";
import { EVENT_VISUAL, STATUS_BADGE_TONE } from "./constants";

export default function TimelineNode({ ev, last, onQuickBill }) {
    const v = EVENT_VISUAL[ev.type] || EVENT_VISUAL.invoice_raised;
    const Icon = v.Icon;
    const statusTone = STATUS_BADGE_TONE[ev.status] || STATUS_BADGE_TONE.Pending;
    const isQuickBillable = ev.type === "milestone_pending" && ev.po_id && ev.milestone_id;

    const Inner = (
        <div className="grid grid-cols-[auto,1fr,auto] gap-4 items-start py-3" data-testid={`timeline-node-${ev.type}-${ev.title?.slice(0, 14)}`}>
            <div className="relative">
                <div className={classJoin("h-9 w-9 rounded-full border-2 flex items-center justify-center", v.ring, v.bg)}>
                    <Icon size={15} className={v.text} weight="fill" />
                </div>
                {!last && <div className="absolute left-1/2 -translate-x-1/2 top-9 bottom-[-1.25rem] w-px bg-slate-200" />}
            </div>
            <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                    <span className={classJoin("text-sm font-semibold truncate", v.text)}>{ev.title}</span>
                    <span className={classJoin("inline-flex items-center rounded px-1.5 py-0.5 text-[9px] font-bold border", statusTone)}>
                        {ev.status}
                    </span>
                </div>
                <div className="text-[11px] text-slate-500 mt-0.5 truncate">{ev.subtitle}</div>
                <div className="text-[10px] text-slate-400 mt-0.5">{formatDate(ev.date)}</div>
            </div>
            <div className="text-right whitespace-nowrap flex flex-col items-end gap-1.5">
                <div className="reedos-data text-sm font-semibold text-slate-900">{ev.amount > 0 ? formatINR(ev.amount) : "—"}</div>
                {isQuickBillable && (
                    <RoleGuard permission="invoice:write">
                        <Button
                            type="button"
                            size="sm"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                onQuickBill?.(ev);
                            }}
                            className="h-7 px-2.5 bg-slate-900 hover:bg-slate-800 text-white text-[11px] font-semibold gap-1"
                            data-testid={`milestone-billnow-btn-${ev.milestone_id}`}
                        >
                            <Receipt size={11} weight="fill" /> Bill now
                        </Button>
                    </RoleGuard>
                )}
            </div>
        </div>
    );
    if (ev.link_to && !isQuickBillable) {
        return (
            <Link to={ev.link_to} className="block hover:bg-slate-50 -mx-2 px-2 rounded-md transition-colors">
                {Inner}
            </Link>
        );
    }
    return Inner;
}
